import { createStyles, makeStyles, Theme } from "@material-ui/core";
import gear from "../../media/gear_1.svg";

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    logoNameContainer: {
      whiteSpace: "nowrap",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginTop: "0px",
      width: "380px",
    },
    nameTop: {
      marginLeft: "10px",
      marginRight: "10px",
      fontSize: "20px",
      marginTop: "10px",
      color: "white",
      fontFamily: "Roboto,Arial,Helvetica,sans-serif",
    },
    nameBottom: {
      color: "#a0b4d2",
      fontSize: "15px",
      width: "0px",
      whiteSpace: "nowrap",
      marginTop: "10px",
      marginLeft: "10px",
    },

    gear: {
      width: "35px",
      marginLeft: "20px",
      transition: "transform .7s ease-in-out",
      "&:hover": {
        transform: "rotate(360deg)",
      },
    },
    line: {
      borderLeft: "2px solid rgb(208, 208, 208)",
      height: "40px",
    },
  });
});

export const LogoName = () => {
  const classes = useStyles();
  return (
    <div className={classes.logoNameContainer}>
      <img src={gear} className={classes.gear}></img>
      <h1 className={classes.nameTop}>Dash AI</h1>
      <div className={classes.line}></div>
      <h2 className={classes.nameBottom}>Your No-Code ML Dashboard</h2>
    </div>
  );
};

export default LogoName;
